// import React from 'react';
// import './Spinner.css'; 

// const Spinner = () => {
//   return (
//     <div className="spinner-wrapper">
//       <div className="spinner" />
//     </div>
//   );
// };

// export default Spinner;

import React from 'react';

const Spinner = () => {
  return (
    <div className="w-5 h-5 border-2 border-white border-t-green-500 rounded-full animate-spin"></div>
  );
};

export default Spinner;


